import http from "@/http/request";
let baseURL = "https://api.szskapp.com/"; //正式
// let baseURL = "http://192.168.3.222:8010/"; //本地测试


export const getAudioList = data => {
  return http({
    method: "get",
    url: baseURL + "go/getH5UserAudio",
    params: data
  });
};

export const getVideoAudioList = data => {
  return http({
    method: "get",
    url: baseURL + "go/getPcAudioList",
    params: data
  });
}

// 竖屏首屏打招呼
export const getVideogreeting = data => {
  return http({
    method: "get",
    url: baseURL + "go/reprocessed/greeting",
    params: data
  });
}

// 上传文件
export const audioPost = (params, data) => {
  return http({
    method: "post",
    url: baseURL + "go/uploadVoice" + params,
    data: data,
    isFormData: true
  });
};

// 上传文件
export const getDialogueList = data => {
  return http({
    method: "get",
    url: baseURL + "go/getDialogueList",
    params: data
  });
};

// 对话文字交互
export const inputPost = (params, data) => {
  return http({
    method: "post",
    url: baseURL + "go/uploadContent" + params,
    data: data,
    isFormData: true
  });
};

export const getDanmu = params => {
  return http({
    method: "get",
    url: baseURL + "go/getBarrageList",
    params
  });
};

export const weixinCodeLogin = params => {
  return http({
    method: "get",
    url: baseURL + "mp/login",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const getUserInfo = params => {
  return http({
    method: "get",
    url: baseURL + "user/info",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
export const addLiuyan = data => {
  return http({
    method: "post",
    url: baseURL + "leave/add",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
export const getLiuyan = params => {
  return http({
    method: "get",
    url: baseURL + "leave/list",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};


// 获取人生传记信息 
export const detileGet = params => {
  return http({
    method: "get",
    url: baseURL + "screen/departed/info",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 获取数字告别信息
export const farewelldetileGet = params => {
  return http({
    method: "get",
    url: baseURL + "go/screen/farewell",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 获取时空联线信息
export const onlinedetileGet = params => {
  return http({
    method: "get",
    url: baseURL + "go/screen/online",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 获取时光印记信息
export const timeimprintGet = params => {
  return http({
    method: "get",
    url: baseURL + "go/screen/timeimprint",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 获取时光追祭信息
export const timememorialGet = params => {
  return http({
    method: "get",
    url: baseURL + "go/screen/timememorial",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 获取讣告信息
export const obituaryGet = params => {
  return http({
    method: "get",
    url: baseURL + "go/screen/obituary",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};

// 修改上香类型
export const stickPost = params => {
  return http({
    method: "post",
    url: baseURL + "screen/update/stick",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 获取消息列表
export const getList = data => {
  return http({
    method: "post",
    url: baseURL + "screen/getList",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 获取访问量
export const getViewNum = data => {
  return http({
    method: "post",
    url: baseURL + "screen/getViewNum",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 谁来了
export const howlist = data => {
  return http({
    method: "post",
    url: baseURL + "attend/list",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// id输入页面三张图片
export const departedinfo = params => {
  return http({
    method: "get",
    url: baseURL + "screen/departed/info",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};

// 发送短信
export const sendcode = data => {
  return http({
    method: "post",
    url: baseURL + "sms/SendCheckCode",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
// 获取用户列表
export const pepolist = data => {
  return http({
    method: "post",
    url: baseURL + "screen/departed/list",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
};

// 获取用户列表
export const spacegetList = params => {
  return http({
    method: "get",
    url: baseURL + "user/space/departed/information",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};

// 菜单
export const authList = params => {
  return http({
    method: "get",
    url: baseURL + "go/departed/auth",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};

// 获取tts文字转语音token
export const ttsToken = params => {
  return http({
    method: "get",
    url: baseURL + "go/asr",
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};